import { ChangeDetectorRef, Component, Input } from '@angular/core';


@Component({
  selector: 'ad-confirm',
  templateUrl: './ad-confirm.component.html',
  styleUrls: ['./ad-confirm.component.scss']
})
export class AdConfirmComponent {
  @Input()
  dialogClass?: string;

  @Input()
  title: string;

  @Input()
  warningIcon: string;

  @Input()
  message: string;

  @Input()
  details: string[] | undefined;

  @Input()
  cancelIcon: string;

  @Input()
  cancelText: string;

  @Input()
  isCancelHidden: boolean = false;

  @Input()
  confirmIcon: string;

  @Input()
  confirmText: string;

  @Input()
  closable: boolean = false;

  @Input()
  confirm: () => void;

  @Input()
  cancel: () => void;

  @Input()
  closeMe: () => void;

  constructor(
  ) {
  }

  onConfirm() {
    this.confirm?.();
  }

  onCancel() {
    this.cancel?.();
  }
  onClose() {

    this.closeMe?.();
  }


}
